import React from 'react';
import { Button, Spinner } from 'react-bootstrap';

/**
 * LoadMoreButton Component
 * Displays a styled button to load more products with loading state and product counter
 * 
 * @param {Function} onClick - Handler for load more action
 * @param {number} remainingCount - Number of products remaining to load
 * @param {number} nextLoadCount - Number of products that will be loaded on next click
 * @param {boolean} loading - Loading state
 * @param {boolean} disabled - Disabled state
 */
const LoadMoreButton = ({
  onClick,
  remainingCount = 0,
  nextLoadCount = 0,
  loading = false,
  disabled = false,
}) => {
  return (
    <div
      className="text-center mt-5"
      data-aos="fade-up"
      data-aos-duration="600"
    >
      <Button
        onClick={onClick}
        disabled={disabled || loading}
        className="px-5 py-3 border-0"
        style={{
          backgroundColor: '#d4a574',
          color: 'white',
          fontSize: '1rem',
          fontWeight: '600',
          fontFamily: 'Georgia, serif',
          letterSpacing: '0.5px',
          borderRadius: '50px',
          boxShadow: '0 4px 20px rgba(212, 165, 116, 0.3)',
          transition: 'all 0.3s ease',
          minWidth: '280px',
          outline: 'none',
        }}
        onFocus={(e) => {
          e.currentTarget.style.boxShadow = '0 4px 20px rgba(212, 165, 116, 0.3), 0 0 0 3px rgba(212, 165, 116, 0.4)';
          e.currentTarget.style.outline = '2px solid #d4a574';
          e.currentTarget.style.outlineOffset = '2px';
        }}
        onBlur={(e) => {
          e.currentTarget.style.boxShadow = '0 4px 20px rgba(212, 165, 116, 0.3)';
          e.currentTarget.style.outline = 'none';
        }}
        onMouseEnter={(e) => {
          if (!disabled && !loading) {
            e.currentTarget.style.backgroundColor = '#c4956a';
            e.currentTarget.style.transform = 'translateY(-3px)';
            e.currentTarget.style.boxShadow = '0 8px 30px rgba(212, 165, 116, 0.4)';
          }
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#d4a574';
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 4px 20px rgba(212, 165, 116, 0.3)';
        }}
        aria-label={`Cargar ${nextLoadCount} productos más. ${remainingCount} productos restantes`}
      >
        {loading ? (
          <>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-2"
            />
            Cargando...
          </>
        ) : (
          <>
            <i className="fas fa-chevron-down me-2"></i>
            Ver más productos
            {remainingCount > 0 && (
              <span
                className="ms-2"
                style={{
                  fontSize: '0.9rem',
                  opacity: 0.9,
                }}
              >
                ({remainingCount} restante{remainingCount !== 1 ? 's' : ''})
              </span>
            )}
          </>
        )}
      </Button>

    </div>
  );
};

export default LoadMoreButton;
